import React from 'react'

export const PlainDocContainer = ({ children }) => {
  return <div className="container   py-5">{children}</div>
}
